import { FormInstance } from 'antd';
import { EnumReportTypes } from '../types/reports';
import { formatAmount } from './formatAmount';

type FieldValues = {
  loanAmount?: number;
  propertyValue?: number;
  purchasePrice?: number;
  loanAmountWithUip?: number;
  cashOut?: number;
  addUip?: boolean;
  addVaFundingFee?: boolean;
  addClosingCosts?: boolean;
  addCashOut?: boolean;
  uipActive?: boolean;
  vaFundingFeeActive?: boolean;
  closingCostsActive?: boolean;
  cashOutActive?: boolean;
  purchasePriceActive?: boolean;
  reportType?: EnumReportTypes;
}

export const calculateLoanToValue = (
  form: FormInstance,
  loanIndex: string | number,
  {
    loanAmount,
    propertyValue,
    purchasePrice,
    loanAmountWithUip,
    addUip,
    addVaFundingFee,
    addClosingCosts,
    addCashOut,
    uipActive,
    vaFundingFeeActive,
    closingCostsActive,
    cashOutActive,
    purchasePriceActive,
    reportType
  }: FieldValues = {}
) => {
  const uipActiveValue = uipActive ?? form.getFieldValue(['tableView', 'uip', 'active']);
  const vaFundingFeeActiveValue = vaFundingFeeActive ?? form.getFieldValue(['tableView', 'vaFundingFee', 'active']);
  const closingCostsActiveValue = closingCostsActive ?? form.getFieldValue(['tableView', 'closingCosts', 'active']);
  const cashOutActiveValue = cashOutActive ?? form.getFieldValue(['tableView', 'cashOut', 'active']);
  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);
  const reportTypeValue = form.getFieldValue(['loans', loanIndex, 'reportType']);

  const isRefinance = (reportType ?? reportTypeValue) === EnumReportTypes.refinance;

  const addUipValue = addUip ?? form.getFieldValue(['loans', loanIndex, 'addUip']);
  const addVaFundingFeeValue = addVaFundingFee ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addVaFundingFee']);
  const addClosingCostsValue = addClosingCosts ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addClosingCosts']);
  const addCashOutValue = addCashOut ??
    form.getFieldValue(['loans', loanIndex, 'externalLoan', 'addCashOut']);

  const loanAmountValue = loanAmount ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmount', 'value'])) || 0);

  const loanAmountWithUipValue = loanAmountWithUip ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'loanAmountWithUip', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  const loanAmountToUse = (
    (addUipValue && uipActiveValue) ||
    (addVaFundingFeeValue && vaFundingFeeActiveValue) ||
    (addClosingCostsValue && closingCostsActiveValue && isRefinance) ||
    (addCashOutValue && cashOutActiveValue)
  ) ? loanAmountWithUipValue : loanAmountValue;

  if (!price) return 0

  const ltvRatio = (loanAmountToUse / price) * 100;

  return parseFloat(formatAmount(ltvRatio));
};
